import React, { useEffect, useState } from 'react'
import NavBarTop from '../Reusable_Components/NavBarTop'
import LeftNavBar from '../Reusable_Components/LeftNavBar'
import { GoSearch } from 'react-icons/go'
import TableComponent from '../Reusable_Components/TableComponent'
import AddEmailTemplate from './AddEmailTemplate'
import axios from 'axios'
import { base_url } from '../../utilities'
import FormLoader from '../Reusable_Components/FromLoader'
import AlertPopUp from '../Reusable_Components/Alert'
import Pagination from '../Reusable_Components/Pagination'
import Footer from '../Login/Footer'
import { useDispatch } from 'react-redux'
import { commercialHeadGetAllFacilitiesForNav } from '../../Redux/Actions/Actions'

export default function EmailTemplates() {

    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(commercialHeadGetAllFacilitiesForNav())
    }, [dispatch])

    const [page, setPage] = useState(1)
    const [emailTemplates, setEmailTemplates] = useState([])
    const [selectedTemplate, setSelectedTemplate] = useState({})
    const [error, setError] = useState(null)
    const [currentPage, setCurrentPage] = useState(1)
    const [totalRecords, setTotalRecords] = useState(0)
    const [reloadEmailTemplates, setReloadEmailTemplates] = useState(false)
    const [templateType, setTemplateType] = useState("All")
    const [appliedTemplateType, setAppliedTemplateType] = useState("All")
    const [searchTerm, setSearchTerm] = useState("")
    const [appliedSearchTerm, setAppliedSearchTerm] = useState("")
    const RECORDS_PER_PAGE = 10


    const handledPaginationNextClicked = () => {
        setCurrentPage(prev => prev + 1)
    }
    const handledPaginationPrevClicked = () => {
        setCurrentPage(prev => (prev > 1 ? prev - 1 : 1))
    }

    const fetchEmailTemplates = () => {
        let filter_condition = {}
        if (appliedTemplateType !== "All") {
            filter_condition = {
                template_type: appliedTemplateType
            }
        }
        setLoading(true)
        let url = base_url + "email/emailTemplate?page_number=" + currentPage + "&items_per_page=" + RECORDS_PER_PAGE + "&filter_condition=" + encodeURIComponent(JSON.stringify(filter_condition));
        if (appliedSearchTerm && appliedSearchTerm.trim() !== "") {
            url += "&search_text=" + encodeURIComponent(appliedSearchTerm);
        }

        axios.get(url)
            .then((response) => {
                setLoading(false)
                setTotalRecords(response.data.info.total_no_of_records)
                setEmailTemplates(response.data.data)
            })
            .catch((error) => {
                setError(error.response.data.message)
                setLoading(false)
                console.log(error)
            })
    }

    const handleApply = () => {
        setAppliedTemplateType(templateType);
        setAppliedSearchTerm(searchTerm);
        setCurrentPage(1);
        setReloadEmailTemplates(prev => !prev);
    }

    const handleClear = () => {
        setTemplateType("All");
        setAppliedTemplateType("All");
        setSearchTerm("");
        setAppliedSearchTerm("");
        setCurrentPage(1);
        setReloadEmailTemplates(prev => !prev);
    }

    // ...existing code...

    useEffect(() => {
        fetchEmailTemplates();
    }, [reloadEmailTemplates, currentPage]);

    return (
        <div>
            <>
                <NavBarTop />
                <LeftNavBar />
            </>
            {page === 1 && <div className='meter_reports_container d-flex flex-column'>
                <div className='d-flex justify-content-between align-items-center' style={{ flex: "0 1 auto" }}>
                    <h3 className="invoice-heading" >Email Templates</h3>
                    <div className='d-flex gap-2'>
                        <button className="invoice_btn" onClick={() => setPage(2)}><img src='./images/icons/AddIcon.svg' alt='add' /> Add Email Template</button>
                    </div>
                </div>
                <div className='d-flex gap-3 align-items-center flex-wrap mt-3'>
                    <div className='email-template-filters d-flex gap-2 align-items-center'>
                        <label>Select Invoice Type</label>
                        <select className='form-select responsive-add-facility-input-fields ' style={{ height: "45px", border: "1px solid #D3D3D3" }} value={templateType} onChange={(e) => {
                            setTemplateType(e.target.value);
                        }}>
                            <option hidden>Select</option>
                            <option value="All">All Invoice Types</option>
                            <option value="Invoice Email">Invoice Email</option>
                            <option value="Set Password Email">Set Password Email</option>
                            <option value="OTP Email">OTP Email</option>
                            <option value="Payment Email">Payment Email</option>
                        </select>
                    </div>
                    <div className='fin_man_meter_search_bar_container'>
                        <input type='search' placeholder='Search' className='fin_man_meter_search_bar' value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                        <GoSearch className='fin_man_meter_search_bar_icon' />
                    </div>
                    <div className='d-flex justify-content-end align-items-center gap-2' >
                        <button className="add_fac_apply_btn primary-button" onClick={handleApply}>Apply </button>
                        <div className='add_fac_apply_btn secondary-button' style={{ cursor: "pointer" }}>
                            <span onClick={handleClear}>Clear</span>
                        </div>
                    </div>
                </div>
                <div className='meter_reports_table_container mt-3' style={{ flex: "1 1 auto", overflow: "auto" }}>
                    <TableComponent
                        headers={[{
                            name: "Template Name",
                            type: "text",
                            key: "template_name",
                            sort: true
                        }, {
                            name: "Invoice Type",
                            type: "text",
                            key: "template_type",
                            sort: true
                        }, {
                            name: "Created By",
                            type: "text",
                            key: "created_by",
                            sort: true
                        }, {
                            name: "Created At",
                            type: "time_stamp",
                            key: "created_at",
                            sort: true
                        }, {
                            name: "Last Updated By",
                            type: "text",
                            key: "updated_by",
                            sort: true
                        }, {
                            name: "Last Updated At",
                            type: "time_stamp",
                            key: "updated_at",
                            sort: true
                        },
                        {
                            name: "Action",
                            type: "button",
                            buttons: [{
                                name: "View",
                                icon: "./images/icons/ViewViewIconEye.svg",
                                disable: (data) => false,
                                action: (data) => {
                                    setSelectedTemplate(data)
                                    setPage(3)
                                }
                            }]
                        }]}
                        data={emailTemplates}
                    />
                </div>
                <div style={{ flex: "0 1 auto" }}>
                    <Pagination
                        handledPaginationNextClicked={handledPaginationNextClicked}
                        handledPaginationPrevClicked={handledPaginationPrevClicked}
                        totalRecords={totalRecords}
                        recordsPerPage={RECORDS_PER_PAGE}
                        currentPaginationPage={currentPage}
                    />
                </div>
            </div>}
            {page === 2 && <AddEmailTemplate setPage={setPage} setReloadEmailTemplates={setReloadEmailTemplates} reloadEmailTemplates={reloadEmailTemplates} />}
            {page === 3 && <AddEmailTemplate setPage={setPage} viewMode={true} selectedTemplate={selectedTemplate} setReloadEmailTemplates={setReloadEmailTemplates} reloadEmailTemplates={reloadEmailTemplates} />}
            {loading && <FormLoader />}
            {error && <AlertPopUp
                alertShow={error}
                alertType="error"
                alertMsg={"Error"}
                alertValue={error}
                alertButtons={[{
                    name: "Close", action: () => {
                        setError(null)
                    }
                }]}
            />}
            <Footer />
        </div>
    )
}
